import { QuoteCheckoutResponse } from "@/main/models/response";
import { ProcurementStatusEnum } from "./enum/StatusProcurement";
import { getTranslateByKey } from "./utils";
export function isCheckoutAwaitingApproval(result: QuoteCheckoutResponse | null | undefined) {
	return result?.idProcurementStatus === ProcurementStatusEnum.AwaitingApproval;
}

export function getCheckoutSuccessMessage(result: QuoteCheckoutResponse | null | undefined) {
	const messageSuccess = getTranslateByKey("information.successfullyGenerateOrder");
	if (!isCheckoutAwaitingApproval(result)) {
		return messageSuccess;
	}

	const messageAwaitingApproval = getTranslateByKey("information.quoteSentToApproval");

	return messageAwaitingApproval || messageSuccess;
}
